module.exports = __webpack_public_path__ + "img/feature-4.ff6ac38.png";